export default class VuplexCommunicator {
    #enabled = false
    #developerMode = false

    constructor(enableDeveloperMode) {
        this.#enabled = window.vuplex ?? false
        this.#developerMode = enableDeveloperMode
    }

    isEnabled() {
        return this.#enabled
    }

    setEnabled() {
        this.#enabled = true
    }

    send(data) {
        if (this.#developerMode) {
            console.log({ vuplex: { send: data } })
            return
        }

        if (!this.#enabled) {
            window.addEventListener('vuplexready', () => {
                this.setEnabled()
                window.vuplex.postMessage(data)
            })
            return
        }

        window.vuplex.postMessage(data)
    }

    sendQuitEvent() {
        this.send({
            data: {
                type: 'quitEvent',
            },
        })
    }
}
